"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = void 0;
var en_json_1 = __importDefault(require("./en.json"));
var fr_json_1 = __importDefault(require("./fr.json"));
var es_json_1 = __importDefault(require("./es.json"));
var de_json_1 = __importDefault(require("./de.json"));
var pt_json_1 = __importDefault(require("./pt.json"));
var ja_json_1 = __importDefault(require("./ja.json"));
var ko_json_1 = __importDefault(require("./ko.json"));
var dynamicContentTranslations = { en: en_json_1.default, fr: fr_json_1.default, es: es_json_1.default, de: de_json_1.default, pt: pt_json_1.default, ja: ja_json_1.default, ko: ko_json_1.default };
exports.default = dynamicContentTranslations;
